import React from 'react';
import { Box, Typography, CircularProgress, LinearProgress } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';

const STEPS = [
    { key: 'preparing', label: 'Preparing Data' },
    { key: 'generating', label: 'Building PDF' },
    { key: 'uploading', label: 'Saving Report' },
    { key: 'done', label: 'Ready' },
];

const phaseOrder = { preparing: 0, generating: 1, uploading: 2, downloading: 3, done: 3, error: 0 };

const StatusCard = ({ phase }) => {
    const currentIndex = phaseOrder[phase] ?? 0;
    const isError = phase === 'error';
    const isDone = phase === 'done';
    const isDownloading = phase === 'downloading';
    const isBusy = !isError && !isDone;

    return (
        <Box sx={{ width: 480, maxWidth: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {STEPS.map((step, idx) => {
                    const completed = !isError && (isDone || isDownloading ? true : idx < currentIndex);
                    const active = !isError && !isDone && !isDownloading && idx === currentIndex;

                    return (
                        <React.Fragment key={step.key}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 84 }}>
                                {completed ? (
                                    <CheckCircleRoundedIcon sx={{ color: '#292D5B', fontSize: 22 }} />
                                ) : active ? (
                                    <CircularProgress size={18} thickness={6} sx={{ color: '#F5A623' }} />
                                ) : (
                                    <RadioButtonUncheckedRoundedIcon sx={{ color: 'rgba(41, 45, 91, 0.3)', fontSize: 22 }} />
                                )}
                                <Typography
                                    sx={{
                                        mt: 0.5,
                                        fontSize: 11,
                                        fontWeight: active || completed ? 600 : 500,
                                        color: completed
                                            ? '#292D5B'
                                            : active
                                                ? '#292D5B'
                                                : 'rgba(41, 45, 91, 0.5)',
                                        textAlign: 'center',
                                        lineHeight: 1.2,
                                    }}
                                >
                                    {step.label}
                                </Typography>
                            </Box>
                            {idx < STEPS.length - 1 && (
                                <Box
                                    sx={{
                                        flex: 1,
                                        height: 3,
                                        mx: 0.5,
                                        mb: 2.2,
                                        borderRadius: 2,
                                        backgroundColor:
                                            !isError && (isDone || isDownloading || idx < currentIndex)
                                                ? '#292D5B'
                                                : 'rgba(41, 45, 91, 0.15)',
                                        transition: 'background-color 0.3s ease',
                                    }}
                                />
                            )}
                        </React.Fragment>
                    );
                })}
            </Box>

            {(isBusy || isDownloading) && (
                <Box sx={{ mt: 1.5 }}>
                    <LinearProgress
                        sx={{
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: 'rgba(41, 45, 91, 0.15)',
                            '& .MuiLinearProgress-bar': {
                                borderRadius: 3,
                                background: 'linear-gradient(90deg, #F5A623, #F7C948)',
                            },
                        }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default StatusCard;
